import React, { Fragment } from 'preact/compat';
import { Field, useFormikContext } from 'formik';
import { EmailFormValues } from './types';
import {
    departmentOptions,
    financeDepartmentOptions,
    jobLocationOptions,
    productTeamOptions,
    regionOptions,
} from '../../../lib/email';
import FormError from '../error';
import FormLabel from '../label';

export default function DepartmentFields() {
    return (
        <div className='form__section'>
            <FormLabel htmlFor='department' required={true}>Enquiry type</FormLabel>
            <div className='form__grid'>
                <div className='form__grid-item  form__field'>
                    <Field as='select' name='department' id='department' className='input  input--select'>
                        <Options placeholder=''>{departmentOptions}</Options>
                    </Field>
                    <FormError name='department' />
                </div>
                <EmptyDepartmentField />
                <DepartmentField department='trade' name='region' options={regionOptions} />
                <DepartmentField department='finance' name='financeDepartment' options={financeDepartmentOptions} />
                <DepartmentField department='careers' name='jobLocation' options={jobLocationOptions} />
                <DepartmentField department='consumerCare' name='productTeam' options={productTeamOptions} />
            </div>
        </div>
    );
}

function EmptyDepartmentField() {
    const {
        values: {
            department,
        },
    } = useFormikContext<EmailFormValues>();

    if (department === '') {
        return (
            <div className='form__grid-item  form__field'>
                <select disabled={true} className='input  input--select' />
            </div>
        );
    }

    return null;
}

function DepartmentField({ department, name, options }: DepartmentFieldProps) {
    const {
        values: {
            department: selectedDepartment,
        },
    } = useFormikContext<EmailFormValues>();

    if (department !== selectedDepartment) {
        return null;
    }

    return (
        <div className='form__grid-item  form__field'>
            <Field as='select' name={name} className='input  input--select'>
                <Options placeholder=''>{options}</Options>
            </Field>
            <FormError name={name} />
        </div>
    );
}

type DepartmentFieldProps = {
    department: string,
    name: string,
    options: object,
};

function Options({ children, placeholder }: OptionsProps) {
    return (
        <Fragment>
            {placeholder !== undefined && (
                <option value=''>{placeholder}</option>
            )}
            {Object.entries(children).map(([value, label]) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </Fragment>
    );
}

type OptionsProps = {
    children: object,
    placeholder?: string,
};
